import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ActiveColumnViewState = {
  activeViewIdByPlan: Record<string, string>
  setActiveView: (planId: string, viewId: string | null) => void
  getActiveView: (planId: string) => string | null
}

export const useActiveColumnViewStore = create<ActiveColumnViewState>()(
  persist(
    (set, get) => ({
      activeViewIdByPlan: {},
      setActiveView: (planId, viewId) =>
        set(state => {
          const next = { ...state.activeViewIdByPlan }
          if (viewId) {
            next[planId] = viewId
          } else {
            delete next[planId]
          }
          return { activeViewIdByPlan: next }
        }),
      getActiveView: planId => get().activeViewIdByPlan[planId] ?? null,
    }),
    { name: 'active-column-view' }
  )
)
